import { Typography } from "@mui/material";
import { Avatar, Box, Card, CardHeader, Grid } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { styled } from "@mui/material";

const ImageWrap = styled(Box)(({ theme }) => ({
	display: "flex",
	justifyContent: "center",
	marginTop: 30,
}));

const CustomLink = styled(Link)(({ theme }) => ({
	textDecoration: "none",
	"& img": {
		transition: ".2s",
	},
	"& .MuiAvatar-root": {
		transition: ".2s",
	},
	"& :hover": {
		"& img": {
			transform: "scale(1.1)",
		},
		"& .MuiAvatar-root": {
			borderColor: theme.palette.admin.text,
		},
	},
}));

const CustomAvatar = styled(Avatar)(({ theme }) => ({
	width: 180,
	height: 180,
	border: "8px solid white",
	"& img": {
		objectPosition: "top",
	},
}));
const EscolaItem = (props) => {
	const { item } = props;

	return (
		<Grid item size={{ md: 4, xs: 12 }} key={item.sku}>
			<CustomLink to={`/admin/escoles/${item.id}`}>
				<Card style={{ backgroundColor: item.color_alt }}>
					<ImageWrap>
						<CustomAvatar
							alt={item.nom}
							src={
								"https://api.sinapsisberga.cat/storage/" +
								item.imatge
							}
							style={{ backgroundColor: item.color }}
						/>
					</ImageWrap>
					<CardHeader
						style={{
							textAlign: "center",
							textDecoration: "none",
						}}
						title={
							<Typography variant="h4" style={{ color: "white" }}>
								{item.nom}
							</Typography>
						}
					/>
				</Card>
			</CustomLink>
		</Grid>
	);
};

export default EscolaItem;
